import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const TooltipTypography = ({ children, title, tooltipClassName, ...props }) => (
  <Tooltip title={title || children} classes={{ tooltip: tooltipClassName }}>
    <Typography
      {...props}
    >
      {children}
    </Typography>
  </Tooltip>
);

TooltipTypography.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  tooltipClassName: PropTypes.string,
};

TooltipTypography.defaultProps = {
  title: null,
  children: '',
  tooltipClassName: '',
};

export default TooltipTypography;
